GetHost = function () {
    const origin = window.location.origin;
    console.log('Origin: ', origin);
    if (origin.includes("http")) {
        return origin;
    }

    return "https://qdbvendorregistration-g8eza4fjhsfwevav.westeurope-01.azurewebsites.net";
}

GetApiCredentials = function (contentType = null) {
    if (contentType != null) {
        return {
            Authorization: "Bearer " + GetToken(),
            Accept: "application/json",
            "Content-Type": contentType,
        };
    }
    return {
        Authorization: "Bearer " + GetToken(),
        Accept: "application/json",
    };
};

VendorRegistrationRequests = async function (
    emailAddress,
    organizationNumber,
    requestCompany,
    businessLineDescription,
    languageId,
    contactPersonMiddleName,
    businessJustificationDescription,
    contactPersonFirstName,
    contactPersonLastName,
    organizationType,
    companyName,
    GITS_Phone,
    postBoxNumber,
    city,
    addressLine1,
    addressLine2,
    countryRegionId,
    webSite,
    state,
    crExpiryDate
) {
    try {
        BlockPage();
        return await axios.post(
            GetHost() + "/api/VendorRegistration/CreateVendorRegistrationRequests",
            {
                emailAddress,
                organizationNumber,
                requestCompany,
                businessLineDescription,
                languageId,
                contactPersonMiddleName,
                businessJustificationDescription,
                contactPersonFirstName,
                contactPersonLastName,
                organizationType,
                companyName,
                GITS_Phone,
                postBoxNumber,
                city,
                addressLine1,
                addressLine2,
                countryRegionId,
                webSite,
                state,
                crExpiryDate
            },
            {
                headers: GetApiCredentials(),
            }
        );
    } catch (error) {
        ErrorAlertMessage(
            error.response?.data || "An error occurred while registering"
        );
        throw error;
    } finally {
        UnBlockPage();
    }
};

GetAddressCountryRegionMaster = async function () {
    try {
        BlockPage();
        const response = await axios.get(
            GetHost() + "/api/VendorRegistration/GetAddressCountryRegionMaster",
            {
                headers: GetApiCredentials(),
            }
        );
        return response.data;
    } catch (error) {
        ErrorAlertMessage(
            error.response?.data || "An error occurred while fetching countries"
        );
        throw error;
    } finally {
        UnBlockPage();
    }
}

GetAddressRegionCityMaster = async function (regionId) {
    try {
        BlockPage();
        const response = await axios.get(
            GetHost() + "/api/VendorRegistration/GetAddressRegionCityMaster?regionId=" +
            regionId,
            {
                headers: GetApiCredentials(),
            }
        );
        return response.data;
    } catch (error) {
        ErrorAlertMessage(
            error.response?.data?.message ||
            "An error occurred while fetching cities"
        );
        throw error;
    } finally {
        UnBlockPage();
    }
};

GetD365Link = async function () {
    try {
        BlockPage();
        const response = await axios.get(
            GetHost() + "/api/VendorRegistration/GetD365Link",
            {
                headers: GetApiCredentials(),
            }
        );
        return response.data;
    } catch (error) {
        ErrorAlertMessage(
            error.response?.data || "An error occurred while fetching D365 Link"
        );
        throw error;
    } finally {
        UnBlockPage();
    }
}